module.exports = __webpack_public_path__ + "img/access-black.0b69a203.svg";